<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#68D389"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12>
        <!-- <v-card> -->
        <v-layout wrap justify-start>
          <!-- <v-card-title class="elevation-0"> -->
          <v-flex
            align-self-center
            text-left
            py-5
            xl3
            lg3
            md3
            pb-2
            sm4
            xs12
            px-5
          >
            <span class="itemHeading">Units</span>
          </v-flex>
          <v-spacer></v-spacer>
          <!-- <v-flex align-self-center text-center pt-5 xl3 lg3 md3 pb-2 sm4 xs12 px-5>
            <v-text-field class="rounded-xl" label="Solo" solo></v-text-field>
          </v-flex> -->
          <v-flex
            py-5
            xl3
            lg3
            text-right
            align-self-center
            md3
            pb-2
            sm4
            xs12
            px-5
          >
            <v-btn
              style="font-family: poppinsmedium"
              dark
              class="rounded-xl"
              block
              color="success"
              to="/Admin/addUnits"
              ><v-icon color="#ffffff">mdi-plus</v-icon>
              <span style="color:#ffffff">
                Add Unit
              </span>
            </v-btn>
          </v-flex>
          <!-- </v-card-title> -->
        </v-layout>
        <v-layout wrap justify-start>
          <v-flex
            xs12
            md6
            sm6
            lg4
            xl3
            align-self-center
            v-for="(item, i) in units"
            :key="i"
            fill-height
            pa-4
          >
            <v-card tile elevation="1" outlined>
              <v-layout wrap justify-center py-4 pa-2>
                <v-flex xs12 px-4 py-2 text-center>
                  <span style="font-family: poppinsbold;font-size:17px">{{
                    item.name
                  }}</span>
                </v-flex>
                <v-flex xs12 px-4 py-0 text-center>
                  <i>
                    <span class="poppinssemibold" style="font-size:13px">
                      ( {{ item.type }} )</span
                    >
                  </i>
                </v-flex>
                <!-- </v-layout>
                <v-layout wrap justify-center py-4> -->
                <v-flex xs12 py-4>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 sm4 align-self-center text-right px-2 py-2>
                  <v-btn
                    color="green"
                    outlined
                    style="font-family: poppinsmedium"
                    small
                    block
                    class="rounded-xl"
                    dark
                    :to="'/Admin/Unit?id=' + item._id"
                  >
                    <span style="color:green">View</span>
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm4 align-self-center text-right px-2 py-2>
                  <v-btn
                    color="teal"
                    depressed
                    style="font-family: poppinsmedium"
                    small
                    block
                    class="rounded-xl"
                    outlined
                    dark
                    :to="'/Admin/editUnit?id=' + item._id"
                  >
                    <span style="color:teal">Edit</span>
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm4 align-self-center text-left px-2 py-2>
                  <v-dialog v-model="item.delete" persistent max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        style="font-family: poppinsmedium"
                        dark
                        block
                        depressed
                        outlined
                        class="rounded-xl"
                        v-on="on"
                        v-bind="attrs"
                        color="error"
                      >
                        <span style="color:red">
                          Delete
                        </span>
                      </v-btn>
                    </template>
                    <v-card class="pa-6">
                      <v-card-title class="poppinssemibold"
                        >Are you sure you want to delete this
                        Unit?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          small
                          dark
                          @click="item.delete = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          color="error darken-1"
                          small
                          dark
                          @click="item.delete = false,deleteItem(item)"
                          >Delete</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-dialog v-model="editdialog" max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">Edit Category</span>
              </v-card-title>
              <v-card-text>
                <v-layout>
                  <v-flex xs12 md12 lg12>
                    <v-text-field
                      v-model="editingitem.name"
                      label=" Category"
                      :rules="[rules.required]"
                      required
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="getdData">
                  Close
                </v-btn>
                <v-btn
                  v-if="!flag"
                  color="blue darken-1"
                  text
                  @click="edit(editingitem._id)"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
        <!-- </v-card> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      ServerError: false,
      msg: null,
      pages: 0,
      dialog: false,
      editdialog: false,
      editingitem: [],
      name: "",
      pageCount: 1,
      appLoading: false,
      editedIndex: -1,
      currentPage: 1,
      flag: false,
      perPage: 4,
      totalData: 0,
      totalRows: 0,
      dialogDelete: false,
      search: "",
      itemname: "",
      addcat: false,

      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
      },
      category: [],
      data: [],
      units: null,
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },
  methods: {
    getdData() {
      this.editdialog = false;
      this.getData();
    },
    initialize() {
      this.admin = [];
    },

    deleteItem(cat) {
      var data = {};
      data["id"] = cat._id;
      axios({
        url: "/unit/remove",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;

            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/view/all/units",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.units = response.data.data;
          // this.totalData = response.data.count;
        })
        .catch(() => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    dialogclose() {
      this.name = null;
      this.dialog = false;
    },

    categoryadd() {
      var data = {};
      data["name"] = this.name;
      axios({
        url: "/category/add",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Added Sucessfully";
            this.showsnackbar = true;
            this.name = null;
            this.dialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    editcat(item) {
      this.editingitem = item;
      this.editdialog = true;
    },
    edit() {
      var data = {};
      data["id"] = this.editingitem._id;
      data["name"] = this.editingitem.name;
      axios({
        url: "/category/edit",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.editdialog = false;

          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Edited Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
  },
};
</script>
